/**
 * Created by Ning Jiang on 11/22/2016.
 */

///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.d.ts"/>
require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomEase.js");

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {PerformanceLogger} from "@nolimitcity/slot-game/bin/dev/performancelogger/PerformanceLogger";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {BetLinesView} from "@nolimitcity/slot-game/bin/core/betline/BetLinesView";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ThorGameModuleConfig} from "./ThorGameModuleConfig";
import {LoaderEvent} from "@nolimitcity/slot-game/bin/core/resource/event/LoaderEvent";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ThorGameConfig} from "./ThorGameConfig";
import {TimelineLite} from "gsap";

export class Thor extends SlotGame {

    private static gameTweakerTest:GameTweakerTest;
    private static performanceLogger:PerformanceLogger;
    private static background:StillImageBackground;
    private static betLinesView:BetLinesView;

    private static ANIMATIONS_TO_PRELOAD:string[] = [
        "reelDust", "reels/reel_a_top", "reels/reel_b_top", "reels/reel_c_top", "reels/reel_d_top", "reels/reel_e_top"
    ];

    constructor() {
        super(ThorGameModuleConfig.instance);
    }

    protected onInitResourcesLoaded(event:LoaderEvent):void {
        if(event.key == ResourcesGroupName.MAIN) {
            const layer:ScalableLayer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.HIDDEN.name);
            const preloadTimeline:TimelineLite = new TimelineLite({onComplete : () => this.onPreloadComplete()});
            for(let i:number = 0; i < Thor.ANIMATIONS_TO_PRELOAD.length; i++) {
                let animation:TimelineSprite = new TimelineSprite(GameResources.getTextures(Thor.ANIMATIONS_TO_PRELOAD[i]));
                layer.addChild(animation);
                preloadTimeline.add(animation.getAnimation());
            }
        }
        super.onInitResourcesLoaded(event);
    }

    private onPreloadComplete():void {
        StageManager.getLayer(ThorGameConfig.instance.LAYERS.HIDDEN.name).removeChildren();
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L2",
                    "M4",
                    "L1",
                    "M2",
                    "L5",
                    "L2",
                    "M1",
                    "L3",
                    "L5"
                ],
                [
                    "L5",
                    "M5",
                    "M1",
                    "L3",
                    "L4",
                    "M2",
                    "L5",
                    "M3",
                    "L4"
                ],
                [
                    "L3",
                    "W",
                    "M5",
                    "L5",
                    "M3",
                    "L2",
                    "L5",
                    "L1",
                    "M4"
                ],
                [
                    "M5",
                    "L2",
                    "L3",
                    "W",
                    "L5",
                    "L1",
                    "M5",
                    "L3",
                    "L4"
                ],
                [
                    "M1",
                    "L5",
                    "L3",
                    "L1",
                    "L2",
                    "M3",
                    "L3",
                    "M5",
                    "L5"
                ]
            ],
            "evaluatedReels": [
                [
                    "M2",
                    "L5",
                    "L2"
                ],
                [
                    "L3",
                    "L4",
                    "M2"
                ],
                [
                    "L5",
                    "M3",
                    "L2"
                ],
                [
                    "W",
                    "L5",
                    "L1"
                ],
                [
                    "L1",
                    "L2",
                    "M3"
                ]
            ],
            "betLineWins": [],
            "totalSpinWinningsNonMultiplied": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 2,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "freespinTriggeredThisSpin": false,
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "extraFreespinRewarded": 0,
            "reelsEnteringFreespin": [
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ]
            ],
            "nudgeRespinTriggered": false,
            "bonusSymbolPosition": -1,
            "overlayWilds": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "overlayWildsBeforeSpinStop": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "overlayWildsAfterSpinStop": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "wildReelsAwardedThisSpin": [
                false,
                false,
                false,
                false,
                false
            ],
            "nudgeFeatureRewarded": "",
            "payoutMultiplierBefore": 1,
            "payoutMultiplierAfter": 1,
            "scatterRespinTriggered": false,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "scatterPositionsBefore": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "scatterPositionsAfter": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "reelsNextSpin": "BASE_REELSET",
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "collectedScattersBefore": 0,
            "collectedScattersAfter": 0,
            "hammerTimeTriggered": false,
            "runeRazeTriggered": false,
            "runeRazeSymbol": "",
            "landedScatterCountBefore": 0,
            "landedScatterCountAfter": 0,
            "meterSpinsCounterBefore": 0,
            "meterSpinsCounterAfter": 0,
            "isRandomWild": false,
            "isReelWild": false
        };
    }
}